import React from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, Button } from '@mui/material';
import rv from '../Assests/rv.jpg';
import Bit from '../Assests/Bit.jpg';
import Pes from '../Assests/Pes.jpg';
import Dayananda from '../Assests/Dayananda.webp';
import Bms from '../Assests/Bms.png';
import Msrit from '../Assests/Msrit.jpg';
import Jss from '../Assests/Jss.jpeg';
import Nhce from '../Assests/Nhce.jpeg';
import Sit from '../Assests/Sit.jpeg';
import Mvit from '../Assests/Mvit.jpeg';
import Rnsit from '../Assests/Rnsit.jpeg';
import Nmit from '../Assests/Nmit.jpeg';

const colleges = [
  {
    name: 'RV College of Engineering',
    description: 'One of the top engineering colleges in Bangalore, offering a variety of B.Tech programs.',
    image: rv,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'Bangalore Institute of Technology',
    description: 'BIT is known for its technical curriculum and excellent placement opportunities.',
    image: Bit,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'PES University',
    description: 'PES University emphasizes research and innovation in its B.Tech programs.',
    image: Pes,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'Dayananda Sagar College of Engineering',
    description: 'DSCE offers a wide range of B.Tech programs and focuses on quality education.',
    image: Dayananda,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'BMS College of Engineering',
    description: 'BMSCE is one of the oldest engineering colleges in Bangalore with great academic excellence.',
    image: Bms,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'MS Ramaiah Institute of Technology',
    description: 'MSRIT is known for producing quality engineers and offering strong placements.',
    image: Msrit,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'JSS Academy of Technical Education',
    description: 'JSSATE Bangalore provides excellent infrastructure and technical education.',
    image: Jss,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'New Horizon College of Engineering',
    description: 'NHCE offers cutting-edge facilities and technical programs for students.',
    image: Nhce,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'Siddaganga Institute of Technology',
    description: 'SIT Tumkur is a premier institute known for academic excellence and research.',
    image: Sit,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'Sir MVIT',
    description: 'Sir M Visvesvaraya Institute of Technology is renowned for quality engineering education.',
    image: Mvit,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'RNS Institute of Technology',
    description: 'RNSIT offers a vibrant academic environment and strong technical programs.',
    image: Rnsit,
    website: 'https://www.getmycollege.com/',
  },
  {
    name: 'Nitte Meenakshi Institute of Technology',
    description: 'NMIT focuses on innovation and technical education for B.Tech students.',
    image: Nmit,
    website: 'https://www.getmycollege.com/',
  },
];

const CollegeCards = () => {
  return (
    <div>
      <Grid container spacing={3} style={{ padding: '20px', justifyContent: 'center' }}>
        {colleges.map((college, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            key={index}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Card
              style={{
                width: '100%',
                border: '2px solid #ddd',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s, box-shadow 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.2)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <CardMedia
                component="img"
                height="180"
                image={college.image}
                alt={`${college.name} image`}
                style={{ borderBottom: '2px solid #ddd', borderRadius: '8px 8px 0 0' }}
              />
              <CardContent style={{ textAlign: 'center', fontSize: '16px' }}>
                <Typography variant="h7" gutterBottom style={{ fontWeight: 'bold' }}>
                  {college.name}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{
                    marginBottom: '10px',
                    textAlign: 'justify',
                    fontSize: '13px',
                  }}
                >
                  {college.description}
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  href={college.website}
                  style={{ color: '#981c1c', borderColor: '#981c1c' }}
                >
                  Read More
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CollegeCards;
